import { 
    SET_CURRENT_ROLE_PERMISSION,
    SET_CURRENT_ROLE_META,
    SET_CURRENT_ROLE_DATA,
    RESET_CURRENT_ROLE_DATA
} from '../actions'
import cloneDeep from 'lodash/cloneDeep'
import { setStateValue, getStateFromPermissions, initCurrentRoleState } from '../rolesUtils'

export default function currentRole(state = initCurrentRoleState, action) {
    const radioNoneOptions = {
        'sm.none': ['sm.full', 'sm.partial'],
        'sm.full': ['sm.none', 'sm.partial'],
        'sm.partial': ['sm.full', 'sm.none'],
        'analytics.sm_full': ['analytics.sm_partial', 'analytics.sm_none'],
        'analytics.sm_partial': ['analytics.sm_full', 'analytics.sm_none'],
        'analytics.sm_none': ['analytics.sm_full', 'analytics.sm_partial'],
        'emailTemplates.modify-none':['emailTemplates.modify'],
        'emailTemplates.delete-none': ['emailTemplates.delete'],
        'emailTemplates.view_all-none': ['emailTemplates.view_all']
    }
    switch(action.type) {
        case SET_CURRENT_ROLE_PERMISSION: {
            const { code, value } = action.payload
            const newPermissions = cloneDeep(state.permissions)
            setStateValue(newPermissions, value, ...code.split('.'))
            if (radioNoneOptions[code]) {
                radioNoneOptions[code].forEach(otherCode => {
                    setStateValue(newPermissions, !value, ...otherCode.split('.'))
                })
            }
            return {
                ...state,
                permissions: newPermissions
            }
        }
        case SET_CURRENT_ROLE_META: {

            const { value, target } = action.payload
            return { 
                ...state,
                fields: {
                    ...state.fields,
                    [target]: {
                        value,
                        error: validateRequired(value) || (
                            target == 'name' ?
                            validateNameLength(value) :
                            validateDescLength(value)
                        )
                    }
                }
            }
        }
        case SET_CURRENT_ROLE_DATA: {
            const { permissions, permissionsData, name, description } = action.payload
            const nextPermissions = permissions || getStateFromPermissions(permissionsData)
            return {
                ...state,
                fields: {
                    name: { 
                        value: name, 
                        error: validateRequired(name) || validateNameLength(name)
                    },
                    description: { 
                        value: description, 
                        error: validateRequired(description) || validateDescLength(description) 
                    },
                },
                permissions: nextPermissions,
                forComparison: {
                    name, description, permissions: nextPermissions
                }
            }
        }   

        case RESET_CURRENT_ROLE_DATA:
            return cloneDeep(initCurrentRoleState)
        default:
            return state
    }
}

function validateRequired(value) {
    return value.trim().length > 0 ? '': 'This is required'
}

function validateMaxLength(maxLength) {
    return function(value) {
        const currentLength = value.trim().length
        return currentLength <= maxLength ? '': `Maximum ${maxLength} characters allowed`
    }
}

const validateNameLength = validateMaxLength(45)
const validateDescLength = validateMaxLength(196)